import { requestWithToken } from '../utilities/request';

const path = '/api/private/';

const fieldList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`work_summaries/field_list`),
    params: param,
  });
};

const workerList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`work_summaries/dayworker_list`),
    params: param,
  });
};

const partnerList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`work_summaries/partner_list`),
    params: param,
  });
};

const getTotalWokerManagerHours = params => {
  return requestWithToken({
    method: 'GET',
    url: 'api/private/work_summaries/total_work_hours',
    params,
  });
};

export const WorkSummariesService = {
  fieldList,
  workerList,
  partnerList,
  getTotalWokerManagerHours,
};

export default WorkSummariesService;



// WEBPACK FOOTER //
// ./src/services/WorkSummaries.js